define('apps/admin/views/modals/bulk-import-upload-modal',[
        'app',
        'njs!apps/admin/templates/includes/modals/_bulk_import_upload_modal(params:tmpl=admin/main/includes/modals/_bulk_import_upload_modal.html)',
    ], function(app, template) {
        'use strict';

        return Mn.ItemView.extend({

            "events": {
                "click .comet-modal__button--cancel": "closeModal",
                "click .comet-modal__button--confirm": "closeModal",
                "click .comet-modal-overlay--backdrop": "closeModal",
            },

            "template": template,

            "initialize": function(opts){
                this.model.set({
                    "showCancelButton": false,
                    "showOKButton": true
                });
            },

            "closeModal": function(event) {
                this.destroy();
            },

        });
});

